module.exports = __webpack_public_path__ + "media/img/careers/why-work/why-work-img5-5950a721926d392dfb57c1814690494e.svg";